import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class Tracks extends Component {
  render () {
    const {
      debug,
      className,
      tracks,
      track,
      onPlayTrack,
      onSetPlayback,
      playback
    } = this.props

    const items = tracks && tracks.map((item, i) =>
      <div key={i}
        className={track === i ? 'track-container current' : 'track-container'}
        onClick={() => {
          onPlayTrack(i)
          if (playback !== 1) {
            onSetPlayback(1)
          }
        }
        }>
        <div className='text'>
          <strong className={track === i ? 'value active' : 'value'}>
            <span className='track-artist'>{item.artist ? item.artist : '(Unknown artist)'}</span> • <span className='track-title'>{item.title ? item.title : '(untitled)'}</span>
          </strong>
        </div>
      </div>
    )

    return (
      <div className={'tracks-container' + className}>
        { debug &&
          <h3>Tracks.jsx</h3>
        }
        {items}
      </div>
    )
  }
}

Tracks.defaultProps = {
  debug: false,
  className: ''
}

Tracks.propTypes = {
  debug: PropTypes.bool,
  className: PropTypes.string,
  tracks: PropTypes.array,
  track: PropTypes.number,
  onPlayTrack: PropTypes.func,
  onSetPlayback: PropTypes.func,
  playback: PropTypes.number
}
